












































import _ from 'lodash'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CompanyGradeReport, CompanyManagerGradeReport, InvestmentStatusReport } from '@/utils/Interfaces'
import BaoCaoTinhHinhDauTu from './BaoCaoTinhHinhDauTu.vue'
import BaoCaoXepLoaiDN from './BaoCaoXepLoaiDN.vue'
import BaoCaoXepLoaiNQLDN from './BaoCaoXepLoaiNQLDN.vue'

@Component({
  components: {
    BaoCaoTinhHinhDauTu,
    BaoCaoXepLoaiDN,
    BaoCaoXepLoaiNQLDN,
  }
})
export default class GiamSatTaiChinhDuLieuBaoCao extends Vue {
  @Prop(Boolean) readonly loading!: boolean
  @Prop(Array) readonly investmentStatusReports!: Array<InvestmentStatusReport>
  @Prop(Array) readonly companyGradeReports!: Array<CompanyGradeReport>
  @Prop(Array) readonly companyManagerGradeReports!: Array<CompanyManagerGradeReport>

  get hasReports () {
    return (
      this.investmentStatusReports.length > 0 ||
      this.companyGradeReports.length > 0 ||
      this.companyManagerGradeReports.length > 0
    )
  }

  // ============================================================================

  reportType = '02.B'
  reportTypes = ['02.B', '05.A', '05.B']

  get tab () {
    return _.indexOf(this.reportTypes, this.reportType)
  }
  set tab (index) {
    this.reportType = this.reportTypes[index]
  }

  // ============================================================================

  get currentComponent () {
    const mapper: { [index: string]: unknown } = {
      '02.B': BaoCaoTinhHinhDauTu,
      '05.A': BaoCaoXepLoaiDN,
      '05.B': BaoCaoXepLoaiNQLDN,
    }
    const component = mapper[this.reportType]
    return component
  }
  
  get currentReports () {
    const mapper: { [index: string]: unknown } = {
      '02.B': this.investmentStatusReports,
      '05.A': this.companyGradeReports,
      '05.B': this.companyManagerGradeReports,
    }
    const reports = mapper[this.reportType]
    return reports
  }
}
